
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"542.672","height":"312.313","viewBox":"0 0 542.672 312.313"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 29864","d":"M3.851 147.166A15.002 15.002 0 0127.34 131.27c46.006 34.491 168.883 110.461 315.997 71.017 77.58-20.093 131.53-92.683 128.404-172.634a15.002 15.002 0 1129.98-1.173C505.394 122.428 442 207.726 350.98 231.3c-159.712 42.822-292.13-38.9-341.643-76.025a14.939 14.939 0 01-5.485-8.108z","fill":"#fff"}})])
          )
        }
      }
    